import { render, staticRenderFns } from "./SubTask.vue?vue&type=template&id=3e2a441b&scoped=true&"
import script from "./SubTask.vue?vue&type=script&lang=js&"
export * from "./SubTask.vue?vue&type=script&lang=js&"
import style0 from "./SubTask.vue?vue&type=style&index=0&id=3e2a441b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2a441b",
  null
  
)

component.options.__file = "SubTask.vue"
export default component.exports